export const areTicketQueuesEnabled = tenantSettings => tenantSettings?.enableTicketQueues !== false;

export const getCreatedTicketVisibleToDriversDefault = tenantSettings => !areTicketQueuesEnabled(tenantSettings);
